var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1542_28455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EFE8FA",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.7807 14.3925L20.0007 18.315L13.2207 14.3925C13.5207 13.8375 13.9557 13.35 14.4432 13.08L18.4482 10.86C19.3032 10.38 20.6982 10.38 21.5532 10.86L25.5582 13.08C26.0457 13.35 26.4807 13.8375 26.7807 14.3925Z",
    fill: "#8746F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.0005 18.3151V25.5001C19.438 25.5001 18.8755 25.3801 18.448 25.1401L14.443 22.9201C13.5355 22.4176 12.793 21.1576 12.793 20.1226V15.8776C12.793 15.3976 12.958 14.8726 13.2205 14.3926L20.0005 18.3151Z",
    fill: "#8746F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2075 15.8776V20.1226C27.2075 21.1576 26.465 22.4176 25.5575 22.9201L21.5525 25.1401C21.125 25.3801 20.5625 25.5001 20 25.5001V18.3151L26.78 14.3926C27.0425 14.8726 27.2075 15.3976 27.2075 15.8776Z",
    fill: "#8746F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1542_28455",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8625 0 0 0 0 0.8625 0 0 0 0 0.8625 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1542_28455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1542_28455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.69f93c05c57c10ac753dd71dcac72a92.svg";
export { ForwardRef as ReactComponent };